import { cloneDeep } from 'lodash';
import { Doughnut } from 'vue-chartjs';
import chartjsPluginDougnutLabel from 'chartjs-plugin-doughnutlabel';
import chartjsPluginDataLabels from 'chartjs-plugin-datalabels';
export default {
  name: 'CoreChartJsDoughnut',
  extends: Doughnut,
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    datasets: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    labels: {
      handler: function () {
        this.render();
      },
      deep: true
    },
    datasets: {
      handler: function () {
        this.render();
      },
      deep: true
    },
    options: {
      handler: function () {
        this.render();
      },
      deep: true
    }
  },
  mounted() {
    this.addPlugin(chartjsPluginDougnutLabel);
    this.addPlugin(chartjsPluginDataLabels);
    this.render();
  },
  methods: {
    render() {
      const clonedOptions = cloneDeep(this.options);

      // TODO: label color based on dark/light theme
      this.renderChart({
        labels: cloneDeep(this.labels),
        datasets: cloneDeep(this.datasets).map(dataset => ({
          borderColor: 'transparent',
          ...dataset
        }))
      }, {
        responsive: true,
        maintainAspectRatio: true,
        ...clonedOptions
      });
    }
  }
};